import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import VueWaypoint from 'vue-waypoint'

Vue.config.productionTip = false
Vue.use(VueWaypoint);

new Vue({
  router,
  store,
  vuetify
}).$mount('#app')
